export default "__VITE_ASSET__c21e826e__"